export class AnuncianteTipo {
  
    constructor(id: number){
      this.id = id;
    }
    
    id: number;
    nome: string;
  }
  